import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewProgramTemplateHeaderWrapper = styled.div`
  margin: 4px 0px;
  .header-right {
    text-align: end;
    margin-top: 16px;

    .header-right-button {
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}
    }

    .header-center-button {
      margin: 0 16px;
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}
    }

    .version-history {
      min-width: 130px;
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}

      .form-header-right {
        width: 100%;

        .item-text {
          color: ${COLORS.cirrus_black};
        }
      }
    }

    .MuiPaper-rounded {
      border-radius: 4px;
      border: 1px solid ${COLORS.cirrus_black5};
    }
  }
`;
